import http from 'plugins/axios';

export default {
  getAuditList(query) {
    return http.get({
      url: '/admin/authRecord/search',
      data: query
    });
  },
  approveAudit({ id, backReason, status }) {
    return http.post({
      url: '/admin/authRecord/update',
      data: {
        id: id,
        backReason: backReason,
        status: status
      },
      dataType: 'form'
    });
  },
  getAuditDetail(id) {
    return http.get({
      url: `/admin/authRecord/detail/${id}`
    });
  },
  groupList(data) {
    return http.get({
      url: '/admin/email/group/list',
      data
    })
  },
};
